import { Modal, ModalProps } from 'antd';

interface CreateShortcutModalProps {
  modalData: ModalProps;
}

export default function CreateShortcutModal({ modalData }: CreateShortcutModalProps) {
  return <Modal {...modalData} footer={false} />;
}
